import axios from 'axios';
import config from '../config';

// Per-company operational settings, fetched at login and cached locally.
// Everything falls back to the old hardcoded values if the fetch fails.
const KEY = 'app_settings';
const DEFAULTS = { poll_fast_sec: 1, poll_normal_sec: 3 };

export async function loadAppSettings() {
  try {
    const { data } = await axios.get(`${config.API_BASE_URL}/company-settings`);
    if (data?.settings) localStorage.setItem(KEY, JSON.stringify(data.settings));
  } catch { /* keep defaults */ }
}

export function getPollMs(kind) {
  let s = DEFAULTS;
  try { s = { ...DEFAULTS, ...(JSON.parse(localStorage.getItem(KEY)) || {}) }; } catch {}
  const sec = kind === 'fast' ? s.poll_fast_sec : s.poll_normal_sec;
  return Math.max(1, Number(sec) || DEFAULTS[kind === 'fast' ? 'poll_fast_sec' : 'poll_normal_sec']) * 1000;
}
